module.exports = __webpack_public_path__ + "img/ecb-logo.0058ac28.jpg";